import './style.less';
import { emailTemplates } from '@prolaera/library';
import { keyBy, values } from 'lodash';

export default function($log, $window, Swal, ProfileClass, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.submit = (formData, reload = true) => {
    if (reload) vm.submitButton = true;
    ApiClass.companiesIdPatch({ manage: true, id: company_id }, formData)
      .then(() => {
        vm.submitButton = false;
        if (reload) $window.location.reload();
        Swal.toast('Updated!');
      })
      .catch(error => {
        vm.submitButton = false;
        $log.error(error);
        throw error;
      });
  };

  vm.updateStatus = (emailTemplate, active) => {
    ApiClass.companiesIdTypeTypeIdPatch(
      {
        manage: true,
        id: company_id,
        type: 'emailTemplates',
        type_id: emailTemplate.id
      },
      { active }
    )
      .then(() => activate())
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function buildTemplateList(configuredTemplates) {
    const emailTemplatesDict = configuredTemplates.reduce((templateListAcc, template) => {
      if (template.id in templateListAcc) {
        templateListAcc[template.id] = {
          ...templateListAcc[template.id],
          ...template
        };
      }

      return templateListAcc;
    }, keyBy(emailTemplates, 'id'));

    vm.emailTemplates = values(emailTemplatesDict);
  }

  function activate() {
    $log.debug('Email Templates Controller Activated');
    ApiClass.companiesIdGet({ manage: true, id: company_id }, null, { queryParams: { emailTemplates: true } })
      .then(({ data: { company, emailTemplates } }) => {
        vm.formData = company;
        if (
          vm.formData.preferences.complianceReports != 'Monthly' &&
          vm.formData.preferences.complianceReports != 'Quaterly'
        )
          vm.formData.preferences.complianceReports = 'false';
        buildTemplateList(emailTemplates);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/emailTemplates/get/index.js